var _defs, _rect, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardWhiteNoBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6f5f6;opacity:.78;}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-17);}.cls-5{fill:url(#linear-gradient-15);}.cls-6{fill:url(#linear-gradient-18);}.cls-7{fill:#e8550d;}.cls-8{fill:#e10814;}.cls-9{fill:url(#linear-gradient-14);}.cls-10{fill:url(#linear-gradient-20);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-16);}.cls-15{fill:url(#linear-gradient-21);}.cls-16{fill:url(#linear-gradient-25);}.cls-17{fill:url(#linear-gradient-5);}.cls-18{clip-path:url(#clippath);}.cls-19{fill:none;}.cls-20{fill:url(#linear-gradient-7);}.cls-21{fill:url(#linear-gradient-24);}.cls-22{fill:url(#linear-gradient-9);}.cls-23{fill:url(#linear-gradient-22);}.cls-24{fill:url(#linear-gradient-3);}.cls-25{fill:#f39d00;}.cls-26{fill:url(#linear-gradient);}.cls-27{fill:#dbe4eb;}.cls-28{fill:url(#linear-gradient-23);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-4);}.cls-31{fill:url(#linear-gradient-8);}.cls-32{fill:#130f30;}.cls-33{fill:url(#linear-gradient-12);}.cls-34{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0,
    y: 0,
    width: 349.52,
    height: 229.87,
    rx: 14.42,
    ry: 14.42,
    transform: "translate(349.52 229.86) rotate(-180)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -720.73,
    y1: 496.68,
    x2: -720.65,
    y2: 496.68,
    gradientTransform: "translate(134385.51 96249.27) scale(186.43 -193.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e20076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e84d18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -720.73,
    y1: 496.75,
    x2: -720.65,
    y2: 496.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -720.73,
    y1: 496.7,
    x2: -720.65,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -720.73,
    y1: 496.72,
    x2: -720.65,
    y2: 496.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -720.73,
    y1: 496.74,
    x2: -720.65,
    y2: 496.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -720.73,
    y1: 496.72,
    x2: -720.65,
    y2: 496.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -720.73,
    y1: 496.7,
    x2: -720.65,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -720.73,
    y1: 496.75,
    x2: -720.65,
    y2: 496.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -720.73,
    y1: 496.75,
    x2: -720.65,
    y2: 496.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -720.73,
    y1: 496.75,
    x2: -720.65,
    y2: 496.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -720.73,
    y1: 496.73,
    x2: -720.65,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -720.73,
    y1: 496.68,
    x2: -720.65,
    y2: 496.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -720.73,
    y1: 496.7,
    x2: -720.65,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -720.73,
    y1: 496.7,
    x2: -720.65,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -720.73,
    y1: 496.7,
    x2: -720.65,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -720.73,
    y1: 496.71,
    x2: -720.65,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -720.73,
    y1: 496.71,
    x2: -720.65,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -720.73,
    y1: 496.71,
    x2: -720.65,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 350,
    height: 230,
    rx: 15,
    ry: 15,
    transform: "translate(350 230) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "cls-1",
    d: "m55.38,239c-28.98-.53-56.84-11.33-78.65-30.49-1.43-1.22-1.92-3.22-1.21-4.96.64-1.74,2.31-2.88,4.16-2.82.05,0,.09,0,.14,0,3.72.18,7.53.53,11.31,1.04,19.78,2.7,51.77,11.14,64.61,14.64h.03s.05-.03.07-.04c17.62-4.37,40.96-9.69,65.25-12.03,3.85-.37,7.67-.57,11.35-.61h.15c1.84.01,3.47,1.21,4.03,2.97.64,1.79.06,3.78-1.43,4.94-6.54,5.28-13.59,9.87-21.05,13.72-.16.08-.32.16-.48.24-18.03,9.21-38.05,13.81-58.27,13.39Zm77.15-32.14h0c-3.69.04-7.44.24-11.14.6-22.8,2.2-44.41,7.02-58.67,10.45,4.97,1.15,24.24,4.71,31.49,6.06,1.16.21,2.04.38,2.56.47,1.75.33,3.53.52,5.31.57,3.69.09,7.35-.74,10.65-2.42,7.27-3.75,14.15-8.23,20.52-13.37.46-.35.64-.96.44-1.51-.15-.51-.62-.86-1.15-.86h0Zm-156.5-15.07c-.61-.01-1.28-.03-2.04-.05-9.07-.33-17.21-5.03-21.77-12.58-.01-.02-1.1-1.94-1.11-1.96-4.51-7.79-8.16-16.05-10.88-24.64-2.27-7.5-1.06-15.64,3.3-22.15,4.45-6.71,11.67-11.05,19.67-11.81,4.77-.47,9.55-.65,14.34-.55,5.11.11,10.2.51,15.26,1.2,24.26,3.31,47.4,9.56,64.86,14.64,17.53-4.35,40.77-9.64,65.1-11.99,5.08-.5,10.19-.7,15.29-.6,4.8.09,9.58.47,14.34,1.13,10.69,1.51,19.43,9.3,22.17,19.78,0,0,0,0,.01,0,.02.05.03.09.04.14,0,.04.01.08.02.12.55,2.23.8,4.53.74,6.83,0,.13-.01.25-.02.38,0,.11-.02.22-.02.33-.05.98-.16,1.95-.32,2.92l-.02.14c-.03.19-.06.38-.1.57-.22,1.16-.52,2.29-.9,3.41,0,.01,0,.02,0,.03,0,.02,0,.03-.01.05-3.29,9.17-7.65,17.91-12.99,26.04h-.01s0,.01,0,.01c-4.84,7.38-13.16,11.77-22.26,11.74-.68,0-1.37-.01-2.06-.02-5.13-.11-10.25-.51-15.34-1.21-24.21-3.31-47.22-9.52-64.56-14.56-17.62,4.38-40.99,9.71-65.4,12.07-5.09.5-10.2.69-15.32.6Zm-1.54-30.21c-.75-.01-1.49-.02-2.22-.02-4.77.01-9.09.93-12.86,2.72-2.79,1.33-4.74,2.85-5.79,4.52-.77,1.23-1.59,3.29.21,6.92.15.26.3.53.44.79.16.29.35.63.55.97,4.04,6.69,11.24,10.86,19.27,11.15h.49s.02.01.02.01c.49.01.98.03,1.48.04,4.99.09,9.98-.1,14.95-.58,23.08-2.23,45.14-7.18,59.72-10.71-26.78-7.78-47.67-12.64-63.87-14.85-4.12-.54-8.26-.86-12.41-.94h0Zm163.49-37.16c-4.98-.09-9.97.1-14.93.59-23.04,2.22-45.01,7.15-59.53,10.66,14.23,4.26,41.44,11.85,63.71,14.73,2.84.35,5.69.55,8.55.59,8.88.18,21.23-.85,29.26-4.24,1.95-.83,3.46-2.45,4.16-4.46.69-1.89.55-3.99-.4-5.76l-.02-.04-.02-.04c-3.68-5.98-9.84-9.99-16.78-10.93-4.63-.64-9.3-1.01-13.97-1.1Zm.25-12.06h0c-5.1-.11-10.2-.51-15.26-1.21-24.26-3.31-47.4-9.56-64.86-14.64-17.52,4.35-40.75,9.64-65.1,11.99-5.08.49-10.19.69-15.29.6-4.8-.09-9.58-.47-14.34-1.12-10.69-1.5-19.43-9.3-22.17-19.78,0,0-.01,0-.02,0-.02-.04-.03-.09-.03-.13,0-.05-.01-.09-.02-.14-.55-2.23-.8-4.53-.74-6.83,0-.15.01-.3.02-.44,0-.09.01-.17.02-.26.05-.98.16-1.95.32-2.92.02-.12.04-.24.06-.36s.04-.23.06-.35c.22-1.16.52-2.3.9-3.41,0-.01.01-.03.01-.05,0,0,0-.02,0-.03,3.29-9.17,7.65-17.91,12.99-26.05,4.85-7.38,13.17-11.78,22.27-11.75.7,0,1.42.01,2.12.02,5.11.11,10.22.51,15.28,1.21,24.19,3.3,47.21,9.51,64.56,14.55,17.63-4.38,41-9.71,65.4-12.06,5.09-.49,10.2-.69,15.31-.6.61.01,1.33.03,2.04.06,9.07.33,17.21,5.03,21.77,12.58,0,.02.92,1.63,1.1,1.95,4.52,7.79,8.17,16.06,10.89,24.65,2.27,7.5,1.06,15.63-3.3,22.14-4.45,6.71-11.67,11.05-19.66,11.82-4.77.47-9.56.65-14.35.56h0ZM-20.02,79.41c-8.88-.18-21.22.84-29.25,4.23-1.95.84-3.46,2.46-4.16,4.47-.69,1.89-.54,3.98.4,5.76.02.03.03.06.05.09,3.68,5.98,9.84,9.99,16.78,10.93,4.63.64,9.3,1,13.97,1.09,4.98.09,9.97-.1,14.93-.59,23.05-2.22,45.02-7.15,59.54-10.66-14.23-4.26-41.42-11.85-63.71-14.73-2.84-.35-5.7-.55-8.56-.59h0Zm159.68-37.67c-4.99-.09-9.99.1-14.96.58-23.09,2.23-45.14,7.18-59.72,10.71,26.39,7.67,47.88,12.66,63.87,14.85,4.12.55,8.28.86,12.44.95.74.01,1.47.02,2.19.02,4.76,0,9.09-.92,12.86-2.72,2.79-1.33,4.73-2.85,5.78-4.52.77-1.24,1.59-3.3-.21-6.91-.09-.16-.18-.32-.27-.48-.06-.1-.11-.2-.17-.3l-.03-.06c-.17-.31-.34-.62-.52-.92-4.05-6.69-11.25-10.86-19.27-11.15-.57-.02-1.18-.04-1.99-.05ZM-16.83,26.67c-1.84-.01-3.47-1.21-4.03-2.97-.64-1.79-.06-3.78,1.44-4.94C-12.89,13.48-5.84,8.88,1.62,5.03c.18-.09.36-.18.55-.27C47.02-18.1,101.19-11.32,139.03,21.89c1.43,1.22,1.92,3.21,1.21,4.96-.63,1.75-2.31,2.89-4.16,2.83-.05,0-.09,0-.14,0-3.76-.18-7.56-.54-11.31-1.05-19.81-2.7-51.78-11.14-64.61-14.64-.05.02-.07.03-.1.04-17.58,4.37-40.88,9.68-65.25,12.03-3.81.37-7.63.58-11.36.62-.05,0-.1,0-.15,0ZM13.7,5.4c-3.7-.09-7.36.74-10.65,2.42-7.27,3.75-14.15,8.23-20.52,13.37-.46.35-.64.96-.44,1.51.15.51.62.87,1.15.86,3.69-.04,7.44-.24,11.14-.6,22.78-2.2,44.4-7.01,58.67-10.45-4.98-1.15-24.27-4.72-31.53-6.06-1.14-.21-2.01-.37-2.52-.47-1.75-.33-3.52-.52-5.3-.57Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.37,19.62s.05,0,.08,0c-.03,0-.05,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m21.7,19.68s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.93,20.58s.06.02.09.02c-.03,0-.06-.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m23.17,19.92c.07.01.14.03.22.04-.07-.02-.15-.03-.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.56,19.81c.08.01.17.03.26.05-.09-.02-.17-.03-.26-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m21.94,19.71c.18.03.38.06.6.1-.2-.04-.4-.07-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.83,19.86c.08.02.17.03.26.05-.09-.02-.17-.03-.26-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m23.64,20.02s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m30.25,24.14c-.07-.01-.15-.02-.23-.04.08.01.15.03.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.43,14.39s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.61,14.34s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m29.29,23.97s-.09-.02-.14-.03c.05,0,.09.02.14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m26.57,23.31s-.02,0-.03,0c0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m29.65,24.04c-.07-.01-.13-.03-.2-.04.07.01.14.03.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m29.95,24.09c-.07-.01-.14-.02-.21-.04.07.01.14.03.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m26.54,23.3s.02,0,.03,0c.67.18,1.6.43,2.58.63.05,0,.09.02.14.03.05.01.1.02.15.03.07.01.14.03.2.04.03,0,.06.01.09.02.07.01.14.03.21.04.03,0,.05,0,.08.01.08.01.15.03.23.04.07.01.14.02.21.03.03,0,.06,0,.09.01.2.03.4.05.59.08.2.02.4.03.6.03.12,0,.24,0,.36,0,.01,0,.03,0,.04,0,.37-.02.75-.07,1.11-.15.52-.12.86-.3.98-.51.07-.13.07-.29,0-.41-.01-.02-.02-.04-.03-.06-.3-.46-.79-.77-1.35-.83-.33-.04-.67-.06-1-.06-.36,0-.71.02-1.07.06-1.69.19-3.3.59-4.52.91.01,0,.03,0,.07.02.06.02.13.04.2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m20.51,25.24c-.85,0-1.28.14-1.5.3-.07.05-.12.11-.15.16-.1.17-.09.38.05.64.01.02.02.03.03.05.01.02.03.05.05.08,0,0,0,0,0,0,.34.52.91.83,1.53.83.05,0,.09,0,.14,0,.36,0,.71-.02,1.07-.06,1.69-.19,3.32-.59,4.54-.91-2.08-.56-3.68-.9-4.89-1.04-.29-.03-.58-.05-.87-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m32.01,18.67c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45,0-.01,0-.02-.01-.04,0-.02-.01-.03-.02-.05-.01-.03-.03-.06-.05-.09-.01-.02-.02-.04-.03-.05-.01-.02-.03-.05-.04-.07,0,0,0,0,0,0h0c-.34-.52-.91-.83-1.53-.83-.05,0-.1,0-.15,0-.36,0-.71.02-1.06.06-1.69.19-3.32.59-4.54.91,2.08.56,3.68.9,4.89,1.04.29.03.58.05.87.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m26.02,20.61s-.06-.02-.09-.02c-.59-.16-1.39-.37-2.24-.55-.02,0-.03,0-.05-.01-.08-.02-.17-.04-.25-.05-.07-.02-.15-.03-.22-.04-.02,0-.05,0-.07-.01-.09-.02-.18-.03-.26-.05,0,0-.02,0-.02,0-.09-.02-.17-.03-.26-.05,0,0,0,0,0,0-.23-.04-.42-.07-.6-.1-.08-.01-.15-.02-.22-.03,0,0-.02,0-.03,0-.11-.01-.21-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.23,0-.34,0-.03,0-.05,0-.08,0-.37.02-.73.07-1.09.15,0,0,0,0,0,0-.13.03-.24.06-.35.1-.01,0-.03.01-.04.02-.04.01-.07.03-.1.04-.02,0-.03.02-.05.02-.03.01-.05.02-.08.04-.02,0-.04.02-.05.03-.02.01-.04.02-.06.04-.02.01-.04.03-.05.04-.01.01-.03.02-.04.03-.02.02-.04.04-.06.05,0,0-.02.01-.02.02-.02.03-.04.05-.06.08-.07.13-.07.29,0,.42,0,0,0,0,0,.01,0,.01.02.03.03.04.3.46.79.77,1.35.83.33.04.67.06,1,.06.36,0,.71-.02,1.07-.06,1.69-.19,3.3-.59,4.52-.91,0,0-.03,0-.06-.02-.05-.02-.11-.03-.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m20.93,16h.01c.26,0,.53-.03.79-.06,1.69-.19,3.31-.59,4.53-.91-.04-.01-.17-.04-.34-.09-.02,0-.05-.01-.06-.02h-.02c-.63-.17-1.78-.46-2.42-.59-.13-.03-.26-.04-.39-.04-.14,0-.28.02-.42.05,0,0,0,0,0,0-.06.01-.12.03-.18.05-.01,0-.02,0-.03,0-.05.02-.11.04-.16.07-.02,0-.03.01-.05.02-.51.27-1,.6-1.45.97-.1.08-.14.22-.09.34.04.12.16.2.29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m31.59,27.91h-.01c-.26,0-.53.03-.79.06-1.69.19-3.31.59-4.53.91.02,0,.18.05.4.11,0,0,0,0,.01,0h0c.63.17,1.78.46,2.42.59.13.03.26.04.39.04.29,0,.57-.07.83-.2h0s0,0,.01,0c.51-.27,1-.6,1.45-.97.1-.08.14-.22.09-.34-.04-.12-.16-.2-.29-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m29.1,29.58c-.64-.13-1.81-.43-2.44-.6-.37-.09-3.27-.83-4.93-1.02-.26-.03-.53-.05-.79-.06h0c-.09,0-.18.04-.23.11-.11.13-.09.32.04.43,1.55,1.28,3.5,1.98,5.52,1.98h0c1.42,0,2.81-.34,4.06-1.01-.26.13-.54.2-.83.2-.13,0-.26-.01-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.43,14.39c.06-.02.12-.04.18-.05,0,0,0,0,0,0,.14-.03.28-.05.42-.05.13,0,.26.01.39.04.66.14,1.89.45,2.5.61.67.17,3.31.82,4.87,1,.26.03.53.05.79.06h0c.09,0,.18-.04.23-.11.11-.13.09-.32-.04-.43-2.7-2.23-6.49-2.61-9.59-.97.01,0,.03-.01.04-.02.05-.03.1-.05.16-.07.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m34.43,23.65h0s0,0,0,0c-.04-.15-.11-.3-.19-.44.07.13.06.28,0,.41-.24.4-1.19.62-2.09.67-.01,0-.03,0-.04,0-.12,0-.24,0-.36,0h0c-.2,0-.4,0-.6-.03-.15-.02-.35-.04-.59-.08-.03,0-.06,0-.09-.01-.07-.01-.14-.02-.21-.03-.08-.01-.15-.02-.23-.04-.03,0-.05,0-.08-.01-.07-.01-.14-.02-.21-.04-.03,0-.06-.01-.09-.02-.07-.01-.14-.03-.2-.04-.05,0-.1-.02-.15-.03-.05,0-.09-.02-.14-.03-.7-.14-1.56-.35-2.58-.63,0,0-.02,0-.03,0-.07-.02-.13-.03-.19-.05h0s-.06-.02-.07-.02c0,0,0,0,0,0,0,0,0,0,0,0-1.22-.32-2.84-.72-4.54-.91-.35-.04-.71-.06-1.06-.06-.33,0-.67.02-1,.06-.56.06-1.05.37-1.35.83-.29.45-.37,1.01-.2,1.52.2.58.47,1.14.79,1.67-.14-.25-.15-.47-.05-.64.03-.05.08-.11.15-.16.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0,0,0,0,0,0,0,1.21.32,2.82.71,4.52.91.35.04.71.06,1.07.06h0s.1,0,.15,0c.62,0,1.2-.32,1.54-.83.36-.56.65-1.17.87-1.8,0,0,0,0,0,0h0c.02-.08.04-.16.06-.24,0-.02,0-.03,0-.05,0-.07.02-.13.02-.2,0,0,0-.01,0-.02,0-.01,0-.02,0-.03,0-.16-.02-.31-.06-.47,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m33.62,17.57s.03.06.05.09c0,.02.01.04.02.05,0,.01.01.02.01.04.06.18.05.33-.03.45-.13.21-.52.46-1.66.46h0c-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,0,0,0,0,0,0-1.22-.32-2.83-.72-4.52-.91-.35-.04-.71-.06-1.07-.06-.05,0-.1,0-.15,0-.62,0-1.2.32-1.53.83-.36.56-.65,1.17-.87,1.8,0,0,0,0,0,0,0,0,0,0,0,0-.02.08-.04.16-.06.23,0,.02,0,.03,0,.05-.01.07-.02.13-.02.2,0,0,0,.01,0,.02,0,0,0,.02,0,.03,0,.16.02.31.06.47,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.04.15.11.3.19.44-.07-.13-.06-.29,0-.42.02-.03.04-.06.06-.08,0,0,.02-.01.02-.02.02-.02.04-.04.06-.05.01-.01.03-.02.04-.03.02-.01.03-.03.05-.04.02-.01.04-.02.06-.04.02-.01.03-.02.05-.03.03-.01.05-.03.08-.04.02,0,.03-.02.05-.02.03-.01.07-.03.1-.04.01,0,.03-.01.04-.02.11-.04.22-.07.35-.1,0,0,0,0,0,0,0,0,0,0,0,0,.33-.08.71-.13,1.09-.15.03,0,.05,0,.08,0,.11,0,.23,0,.34,0,.2,0,.4,0,.6.03.09,0,.19.02.31.04,0,0,.02,0,.03,0,.07,0,.15.02.22.03.2.03.4.06.6.1,0,0,0,0,0,0,.09.01.17.03.26.05,0,0,.02,0,.02,0,.09.02.17.03.26.05.02,0,.05,0,.07.01.07.01.15.03.22.04.08.02.17.03.25.05.02,0,.03,0,.05.01.63.14,1.38.32,2.24.55.03,0,.06.02.09.02.06.02.11.03.17.05.04.01.06.02.07.02,0,0,0,0,0,0,0,0,0,0,0,0,1.22.32,2.84.72,4.54.91.35.04.71.06,1.07.06h0c.33,0,.67-.02,1-.06.55-.06,1.05-.37,1.35-.83.3-.45.37-1.01.2-1.52-.2-.58-.47-1.14-.79-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m21.72,19.68c.07,0,.15.02.22.03-.08-.01-.15-.02-.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m21.72,19.68c.07,0,.15.02.22.03-.08-.01-.15-.02-.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m26.18,20.65c-.06-.02-.11-.03-.17-.05.06.02.12.03.17.05.03,0,.05.01.06.02,0,0,0,0,0,0,0,0-.03,0-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m26.18,20.65c-.06-.02-.11-.03-.17-.05.06.02.12.03.17.05.03,0,.05.01.06.02,0,0,0,0,0,0,0,0-.03,0-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m31.14,18.62c.29.03.58.05.87.05h0c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45.06.18.05.33-.03.45-.13.21-.52.46-1.66.46-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,2.08.56,3.68.9,4.89,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m31.14,18.62c.29.03.58.05.87.05h0c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45.06.18.05.33-.03.45-.13.21-.52.46-1.66.46-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,2.08.56,3.68.9,4.89,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m22.55,19.81s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m22.55,19.81s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m19.28,19.77c.36-.08.72-.13,1.09-.15-.37.02-.75.07-1.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m19.28,19.77c.36-.08.72-.13,1.09-.15-.37.02-.75.07-1.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m21.38,19.64c.1.01.21.02.31.04-.12-.02-.22-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.22,0-.34,0,.11,0,.22,0,.34,0,.2,0,.4,0,.6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m21.38,19.64c.1.01.21.02.31.04-.12-.02-.22-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.22,0-.34,0,.11,0,.22,0,.34,0,.2,0,.4,0,.6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m23.1,19.91s.05,0,.07.01c-.02,0-.05-.01-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m23.1,19.91s.05,0,.07.01c-.02,0-.05-.01-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m23.69,20.03c.85.18,1.65.39,2.24.55-.86-.24-1.61-.42-2.24-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m23.69,20.03c.85.18,1.65.39,2.24.55-.86-.24-1.61-.42-2.24-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m30.02,24.11s-.05,0-.08-.01c.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.02,24.11s-.05,0-.08-.01c.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m22.6,14.34c-.06.01-.12.03-.18.05.06-.02.12-.04.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m22.6,14.34c-.06.01-.12.03-.18.05.06-.02.12-.04.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m22.81,19.85s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.81,19.85s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m22.24,14.47c.05-.03.1-.05.16-.07-.05.02-.11.04-.16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m22.24,14.47c.05-.03.1-.05.16-.07-.05.02-.11.04-.16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m23.03,14.29c-.14,0-.28.02-.42.05.14-.03.28-.05.42-.05.13,0,.26.01.39.04.63.13,1.78.43,2.42.59h.02s.04.01.06.02c-.61-.16-1.84-.47-2.5-.61-.13-.03-.26-.04-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23.03,14.29c-.14,0-.28.02-.42.05.14-.03.28-.05.42-.05.13,0,.26.01.39.04.63.13,1.78.43,2.42.59h.02s.04.01.06.02c-.61-.16-1.84-.47-2.5-.61-.13-.03-.26-.04-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m23.39,19.97c.08.02.17.04.25.05-.09-.02-.17-.04-.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m23.39,19.97c.08.02.17.04.25.05-.09-.02-.17-.04-.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m29.5,29.62c-.13,0-.26-.01-.39-.04-.64-.13-1.79-.43-2.42-.59h0s0,0-.01,0c.62.16,1.8.46,2.44.6.13.03.26.04.39.04.29,0,.57-.07.83-.2h0c-.26.13-.54.2-.83.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.5,29.62c-.13,0-.26-.01-.39-.04-.64-.13-1.79-.43-2.42-.59h0s0,0-.01,0c.62.16,1.8.46,2.44.6.13.03.26.04.39.04.29,0,.57-.07.83-.2h0c-.26.13-.54.2-.83.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m30.46,24.18c-.07-.01-.14-.02-.21-.03.07.01.15.02.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m30.46,24.18c-.07-.01-.14-.02-.21-.03.07.01.15.02.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m29.74,24.05s-.06-.01-.09-.02c.03,0,.06.01.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m29.74,24.05s-.06-.01-.09-.02c.03,0,.06.01.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m21.38,25.29c-.29-.03-.58-.05-.87-.05-.85,0-1.29.14-1.5.3.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0-2.08-.56-3.68-.9-4.89-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m21.38,25.29c-.29-.03-.58-.05-.87-.05-.85,0-1.29.14-1.5.3.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0-2.08-.56-3.68-.9-4.89-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m26.34,23.25h0c.07.02.13.04.19.05-.07-.02-.14-.04-.2-.06-.03,0-.06-.02-.07-.02,0,0,0,0,0,0,0,0,.03,0,.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m26.34,23.25h0c.07.02.13.04.19.05-.07-.02-.14-.04-.2-.06-.03,0-.06-.02-.07-.02,0,0,0,0,0,0,0,0,.03,0,.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m29.15,23.94c-.98-.2-1.92-.44-2.58-.63,1.02.28,1.88.48,2.58.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m29.15,23.94c-.98-.2-1.92-.44-2.58-.63,1.02.28,1.88.48,2.58.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m29.45,24c-.05-.01-.1-.02-.15-.03.05.01.1.02.15.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m29.45,24c-.05-.01-.1-.02-.15-.03.05.01.1.02.15.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "cls-32",
    d: "m66.91,29.55h-2.02v-11.12h1.65l.28.78c.69-.6,1.62-.93,2.59-.93,2.56,0,4.08,2.25,4.08,4.43s-1.53,4.43-4.1,4.43c-.91,0-1.82-.3-2.49-.83v3.24h0Zm2.23-9.42c-1.29,0-2.34,1.17-2.34,2.6s1.05,2.57,2.34,2.57,2.32-1.14,2.32-2.59-1.02-2.59-2.32-2.59Zm25.1,7.02c-2.55,0-4.48-1.89-4.48-4.4s1.83-4.46,4.27-4.46c2.62,0,3.99,2.17,3.99,4.31,0,.42-.05.69-.05.7l-.06.31h-6.03c.12.51.41.94.83,1.24.42.3.96.46,1.56.46.7,0,1.49-.18,2.23-.5l.35-.15.72,1.61-.32.16c-.33.17-1.53.72-3.01.72Zm-.14-7.02c-1.08,0-1.94.69-2.21,1.76h4.15c-.05-.34-.19-.83-.56-1.21-.35-.36-.81-.55-1.38-.55h0Zm-41.7,7.02c-2.49,0-4.43-1.95-4.43-4.43s1.95-4.43,4.43-4.43,4.46,1.95,4.46,4.43c0,2.49-1.96,4.43-4.46,4.43Zm0-7.02c-1.34,0-2.4,1.14-2.4,2.59s1.05,2.59,2.4,2.59,2.41-1.14,2.41-2.59-1.04-2.59-2.41-2.59Zm-9.07,7.02c-2.49,0-4.43-1.95-4.43-4.43s1.95-4.43,4.43-4.43c1.56,0,2.98.77,3.79,2.07l-1.79.89c-.44-.7-1.17-1.1-2-1.1-1.34,0-2.4,1.14-2.4,2.59s1.05,2.59,2.4,2.59c.4,0,.8-.1,1.15-.3.34-.2.63-.47.84-.81l1.8.89c-.81,1.29-2.23,2.07-3.79,2.07Zm44.24-.15h-2v-6.57l-1.04-.37v-1.63h1.04v-1.5c0-1.61,1.17-1.95,2.16-1.95h1.21v1.71h-.55c-.45,0-.81.36-.81.8v.95h1.36v1.63h-1.36v6.94h0Zm-4.93,0h-2.02v-6.57l-1.04-.37v-1.63h3.06v8.57h0Zm-3.89,0h-1.21c-.98,0-2.16-.34-2.16-1.95v-10.07h2v9.52c0,.44.36.8.81.8h.55v1.71h0Zm-17.98,0h-2.02v-8.57h1.65l.26.73c.57-.48,1.32-.73,2.23-.73h.38v1.98h-.38c-1.6,0-2.04.89-2.13,1.63v4.95h0Zm20.7-9.08c-.67,0-1.2-.53-1.2-1.2s.53-1.2,1.2-1.2,1.23.54,1.23,1.19c0,.67-.55,1.22-1.23,1.22h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m313.52,195.06h7.48v14.96h-7.48v-14.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m313.46,202.49c0-2.98,1.4-5.62,3.55-7.32-1.58-1.24-3.57-1.99-5.75-1.99-5.15,0-9.32,4.17-9.32,9.32s4.17,9.32,9.32,9.32c2.17,0,4.17-.75,5.75-1.99-2.15-1.68-3.55-4.35-3.55-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m332.09,202.49c0,5.15-4.17,9.32-9.32,9.32-2.17,0-4.17-.75-5.75-1.99,2.17-1.71,3.55-4.35,3.55-7.32s-1.4-5.62-3.55-7.32c1.58-1.24,3.57-1.99,5.75-1.99,5.15,0,9.32,4.19,9.32,9.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWhiteNoBack);
export default __webpack_public_path__ + "static/media/card_white_no_back.5213e3487ba00b815c8a04435f202d42.svg";
export { ForwardRef as ReactComponent };